var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02246 3.17461L3.16247 3.64138C3.20093 3.76902 3.47663 3.8987 3.92878 3.8987C4.20642 3.8987 4.51458 3.85025 4.81991 3.75847C5.71646 3.48889 6.20855 2.9681 6.14059 2.74187L6.00239 2.27963C5.33989 2.94066 3.98348 3.37791 3.02259 3.17459L3.02246 3.17461Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61818 2.06851L6.76364 2.55491C6.9673 3.23362 6.21212 4.01899 5.00715 4.38128C4.10493 4.65245 2.79163 4.66391 2.5394 3.82883L2.41573 3.41891C1.40502 4.37219 0.833984 5.69072 0.833984 7.1051C0.833984 9.90868 3.11341 12.1896 5.91554 12.1896C8.71912 12.1896 11 9.90857 11 7.1051C11 4.53752 9.1101 2.40841 6.61815 2.06857L6.61818 2.06851Z",
    fill: "#8D8E92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55882 1.5097C3.06743 1.75727 2.69663 2.09764 2.76198 2.31299C2.8978 2.78327 4.35552 2.539 5.01724 2.19045L5.01735 2.19033C5.73182 1.81332 5.72659 1.51424 5.74791 1.48168C5.77775 1.22923 5.22939 1.16037 4.9739 1.16037C4.732 1.16037 4.46583 1.20338 4.19919 1.27338L3.28765 0.110881C3.16897 -0.0243617 2.96315 -0.0376385 2.82838 0.0806996C2.69336 0.199038 2.67975 0.404618 2.7982 0.539767L3.55882 1.5097Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMines);
export default __webpack_public_path__ + "static/media/mines.6f1bc82c080ecc1ee16b6f5dbc0ae552.svg";
export { ForwardRef as ReactComponent };